import styled from "styled-components";
import { BodyDefault } from "../typography/styled";


export const Container = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;

  .tox-tinymce,
  .tox-editor-container,
  .tox-editor-header {
    max-width: 100%;
  }
`

export const ErrorText = styled(BodyDefault)`
  color:${({theme}) => theme.errors[600]};
  margin-top: 6px;
  &:first-letter {
    text-transform: uppercase;
  }
`
